import { Icon } from '@iconify/react'
import { motion, AnimatePresence } from 'framer-motion'

// Controlled, labeled collapsible group used to stack the Creative and
// Research nav trees in the single sidebar. Open state is owned by the
// parent so persistence + active-area logic live in one place (MainSidebar).
export const CollapsibleNavSection = ({ label, icon, count, isOpen, onToggle, action, children }) => {

    return (
        <div className="flex flex-col">
            <div className="flex items-center justify-between pr-1">
                <button
                    type="button"
                    onClick={onToggle}
                    className="flex flex-1 items-center gap-1.5 px-3 py-1.5 text-xs font-medium uppercase tracking-wide text-muted-foreground hover:text-foreground transition-colors"
                >
                    <Icon
                        icon="ph:caret-right"
                        className={`h-3 w-3 transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
                    />
                    {icon && <Icon icon={icon} className="h-4 w-4" />}
                    <span>{label}</span>
                    {count != null && (
                        <span className="rounded-full bg-muted px-1.5 py-px text-[10px] tracking-normal text-muted-foreground">
                            {count}
                        </span>
                    )}
                </button>
                {action}
            </div>

            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        key={`${label}-body`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}
